<template>
    <div>
        <el-select
            :value="selected"
            @input="dispatch"
            :multiple="multiple"
            :placeholder="placeholder || $t('message.company')"
            filterable
            clearable
            :collapse-tags="collapseTags"
            :size="size"
            class="d-block"
            :class="mode ? 'input__day' : 'input__night'"
        >
            <el-option
                v-for="(company, index) in companies"
                :key="'companies-' + index"
                :label="company.name"
                :value="company.id"
            ></el-option>
        </el-select>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
    props: {
        size: {
            default: "small",
        },
        placeholder: {
            default: null,
        },
        id: {
            default: null,
        },
        multiple: {
            default: false,
        },
        collapseTags: {
            default: false,
        },
    },
    watch: {
        id: {
            handler: function () {
                this.selected = this.id;
            },
            immediate: true,
            deep: true,
        },
    },
    data() {
        return {
            selected: null,
        };
    },
    mounted() {
        if (this.companies && this.companies.length === 0)
            this.updateInventory();
    },
    computed: {
        ...mapGetters({
            companies: "company/inventory",
            mode:'MODE'
        }),
    },
    methods: {
        ...mapActions({
            updateInventory: "company/inventory",
        }),
        dispatch(e) {
            this.$emit("input", e);
            this.selected = e;
        },
    },
};
</script>
